import {useParams} from "react-router-dom";
import {ViewDocumentPanel} from "document/component/container";
import {EDARService} from "saneamiento/service";

const ViewEDARDocumentPanel = () => {
    const {idEdar} = useParams();

    const handleSetFeaturedImage = documentId => {
        return EDARService.updateWithPatch({
            id: idEdar,
            featured_image: documentId,
        });
    };

    const handleSetFeaturedDocument = documentId => {
        return EDARService.updateWithPatch({
            id: idEdar,
            featured_document: documentId,
        });
    };

    return (
        <ViewDocumentPanel
            onSetFeaturedImage={handleSetFeaturedImage}
            onSetFeaturedDocument={handleSetFeaturedDocument}
        />
    );
};

export default ViewEDARDocumentPanel;
